// extracted by mini-css-extract-plugin
module.exports = {"cardOuter":"_1ldEi","gradientImage":"_2vvnN","comaWrap":"_1JGzV","mediaWrap":"LcvGI","name":"_20cE_","location":"_1dYi8","comment":"_3Gfrf","readMore":"_3bkp7","expanded":"_3kRCp"};